// lib/list/listRetryAllowance.ts
export const LIST_GENERATION_ATTEMPT_LIMIT = 10;

/** Explicit replay allowances are separate from a fresh generation's automatic recovery. */
export function listRetryAttemptLimit(prompt: string): number | undefined {
  const request = prompt.trim().toLowerCase().replace(/[.!]+$/, '').trim();
  if (/^(?:please )?(?:retry|try again|retry that)$/.test(request)) return 1;
  if (/^(?:please )?(?:keep trying(?: until it works)?|continue trying until it works|réessaie jusqu'à ce que ça marche)$/.test(request)) return LIST_GENERATION_ATTEMPT_LIMIT;
  const counted = /^(?:please )?retry up to (-?\d+) times?$/.exec(request);
  if (!counted) return undefined;
  return Math.max(0, Math.min(LIST_GENERATION_ATTEMPT_LIMIT, Number(counted[1])));
}

/** Kept outside model-authored scripts; a replay cannot claim another allowance. */
export function createListRetryClaim(prompt: string, isUserTurn: boolean) {
  const limit = isUserTurn ? listRetryAttemptLimit(prompt) : undefined;
  if (limit === undefined) return undefined;
  let claimed = false;
  return () => {
    if (claimed) return 0;
    claimed = true;
    return limit;
  };
}
